/** Visually hidden skip link — first tab stop, jumps to #main-content. */
import { Link } from '@mui/material';
import { useT } from '@/i18n/useT';

const skipLinkSx = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
  '&:focus': {
    position: 'fixed',
    top: 8,
    left: 8,
    zIndex: 2000,
    width: 'auto',
    height: 'auto',
    margin: 0,
    padding: '8px 16px',
    overflow: 'visible',
    clip: 'auto',
    whiteSpace: 'normal',
    bgcolor: 'background.paper',
    color: 'text.primary',
    boxShadow: 3,
    borderRadius: 1,
    textDecoration: 'none',
  },
};

/**
 * @param {{ disabled?: boolean }} props
 * When disabled (content-first pages where main is already first in tab order),
 * render nothing so Tab lands on the first task panel immediately.
 */
export default function SkipToContentLink({ disabled = false }) {
  const t = useT();

  if (disabled) return null;

  const handleActivate = (event) => {
    event.preventDefault();
    const main = document.getElementById('main-content');
    if (!main) return;
    main.focus({ preventScroll: false });
    main.scrollIntoView?.({ block: 'start' });
  };

  return (
    <Link
      href="#main-content"
      onClick={handleActivate}
      sx={skipLinkSx}
    >
      {t('a11y.skipToContent', 'Skip to main content')}
    </Link>
  );
}
